import { render } from "./HeaderVendas.vue?vue&type=template&id=5ba1de8d&scoped=true"
import script from "./HeaderVendas.vue?vue&type=script&lang=js"
export * from "./HeaderVendas.vue?vue&type=script&lang=js"

import "./HeaderVendas.vue?vue&type=style&index=0&id=5ba1de8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba1de8d"]])

export default __exports__